import React from 'react';
import { IWidthButtonParams } from "./IWidthButtonParams";

export function WidthButton(params: IWidthButtonParams) {
    return <button onClick={() => { params.onWidthChanged(); }}>Stripes</button>;
}
